import axios from './axios'
import config from '../../config'
import { URLSearchParams } from 'url'

export default {

    getAll: (type, f) => {
        let query = "?orderByColumn=listOrder&orderByDir=asc"
        if (type == "roles") {
            query = "?orderByColumn=name&orderByDir=asc"
        }
        axios.get("/" + type + query).then(r => {
            f(r.data)
        })
    },

    create: (type, data, f) => {
        axios.post("/" + type, data).then(r => {
            f(r.data)
        })
    },

    update: (type, id, data, f) => {
        axios.put("/" + type + "/" + id, data).then(r => {
            f(r.data)
        })
    },

    move: (type, id, to, f) => {
        axios.put("/" + type + "/" + id + "/move/" + to).then(r => {
            f(r.data)
        })
    },

    delete: (type, id, f) => {
        axios.delete("/" + type + "/" + id).then(r => {
            f(r.data)
        })
    },

    search: (type, data, f) => {
        axios.get("/" + type, { params: data }).then(r => {
            f(r.data)
        })
    },

    new: function (model) {
        return {
            type: model,
            get: (params, callback) => {
                axios.get("/" + model, { params: params }).then(res => {
                    callback(res.data)
                })
            },

            export: (params) => {
                window.open(config.axiosConfig.baseURL + "/" + model + "?" + (new window.URLSearchParams(params)).toString(), "_blank")
            }
        }
    }

}